import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
//按需引入element-ui
import elementComponents from './element';
import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';
import mixin from './mixins'
elementComponents.forEach(comp=>{
    Vue.use(comp)
})

Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import Http from './common/http';
import Api from './common/api';
import ElementUI from 'element-ui';
import components from './common/component';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Http);
Vue.use(Api);
Vue.use(components);
Vue.use(Viewer);//放大图片
Vue.mixin(mixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
